:host {
    display: block;

    .headline {
        @include typo-ws-h3;

        margin: 8px 16px 0 0;
    }

    sew-input:first-of-type,
    sew-checkbox {
        margin-top: 24px;
    }

    sew-input {
        width: 100%;
    }

    sew-input[error]:not(:first-of-type) {
        margin-top: 24px;
    }

    sew-ws-linklist {
        margin-top: 32px;
    }

    sew-ws-button {
        margin-top: 40px;
        width: 100%;
    }
}
